export default __webpack_public_path__ + "static/media/icon_speaker_play.5727b58c.svg";